/// <reference path="../../../../typings/tsd.d.ts" /> 
module warsApp.models {
    export class ProcessConditionsModel {
        private logType: string = "ProcessConditionsModel";

        public selectedCondition: Wars.Domain.Model.Conditions.Condition;
        public processConfiguration: Wars.Domain.Model.ProcessConfiguration;
        public search: any;

        public editingCondition: boolean;

        constructor(
            private processConfigId: string,
            private conditionId: string,
            private processConfigService: services.ProcessConfigurationService,
            private conditionService: services.ConditionService,
            private deleteService: services.DeleteService)
        {
            this.editingCondition = false;

            this.processConfigService.getProcessConfigurationEagerLoadConditions(this.processConfigId).then(
                (appConfig) => {
                    this.processConfiguration = appConfig;
                });

            this.search = {
                name: ''
            }

            this.processConfigService.getProcessConfigurationEagerLoadConditions(this.processConfigId).then(
                (processConfig) => {
                    this.processConfiguration = processConfig;
                    if (conditionId) {
                        const match = Enumerable.from(this.processConfiguration.myConditions).singleOrDefault(i => i.id === conditionId);
                        if (match) {
                            this.search.name = match.name;
                            this.editCondition(match);
                        }
                    }
                });
        }

        public editCondition(condition: Wars.Domain.Model.Conditions.Condition): void {
            this.editingCondition = true;
            this.selectedCondition = condition;
            services.WarsLogger.logDebug("Selected Condition", this.logType, this.selectedCondition);
        }

        public deleteCondition(condition: Wars.Domain.Model.Conditions.Condition): void {
            this.deleteService.deleteWithModalConfirmationIfNecessary(
                "Condition",
                condition.id,
                "Condition Successfully Deleted",
                () => {
                    this.processConfiguration.myConditions.remove(condition);
                },
                "Condition Could not be Deleted");
        }

        public addNewCondition(): void {
            this.selectedCondition = this.processConfigService.createNewCondition();

            this.editingCondition = false;
        }

        public cancelSave(): void {
            this.selectedCondition = undefined;
            this.processConfigService.rejectChanges();
            this.processConfiguration.myConditions.pop();
        }

        public saveCondition(): void {
            var condition = <Condition>this.selectedCondition;

            if (!this.editingCondition) {
                this.selectedCondition.processConfiguration_id = this.processConfigId;
                this.processConfiguration.myConditions.push(condition);
            }

            var exp = condition.expression;
            this.setGroupExpressionDefaults(exp);

            this.editingCondition = false;
            this.processConfigService.saveAllChanges();
            this.selectedCondition = undefined;
        }

        private setGroupExpressionDefaults(expression: Wars.Domain.Model.Conditions.Expression) {
            if (expression.expressionType === Wars.Domain.Model.Codes.Enums.ExpressionType.Group) {
                var ge = (<Wars.Domain.Model.Conditions.GroupExpression> expression);
                if (ge.isAnd === null) {
                    ge.isAnd = false;
                }
                if (ge.children != null) {
                    for (var i = 0; i < ge.children.length; i++) {
                        this.setGroupExpressionDefaults(ge.children[i]);
                    }    
                }
            }
            
        }
    }
}